@charset "UTF-8";

/* src/app/features/tranches/cadastro/tranches-cadastro.componet.scss */
.removeTopBorder {
  border-top: none;
}
.subTitulo {
  margin-top: 20px;
}
#pointer :hover {
  cursor: pointer;
}
#btn-adicionarFator {
  margin: 8px;
  margin-left: 0;
}
.evento-distribuicao {
  display: flex;
  gap: 3em;
}
#table-container {
  max-height: 300px;
  overflow-y: auto;
}
.fundo-inativo {
  background-color: rgb(236, 236, 236);
}
/*# sourceMappingURL=tranches-cadastro.componet.css.map */
